<script>
	import Helper from './components/Helper.svelte';
	import { sucursal,sucursalStore,miPermiso } from './stores/store';
	import Modal from './components/Modal.svelte';
    import BotonCaja from './componentes/BotonCaja.svelte';    
    import { login, prefix, urlapi, viewsXpages } from './stores/store';
    import Navbar from './components/Navbar.svelte';
    import AnimationContainer from './components/AnimationContainer.svelte';
    import Titlesection from "./components/Titlesection.svelte";
    import { object2array, postData } from './scripts';
    import { push } from 'svelte-spa-router';

    export let params = {}
    let id=params.id;
    let helper=false;
    let insertando=false;
    let color='#000000';
    let nombre='';
    let precio='1.00';
    let existencia=0;
    let codigo='';
    let visualizar=false;
    let editable=false;

    let disabled=true;
    let avatar=false, fileinput;
    let loader=false;

	const onFileSelected =(e)=>{
    let image = e.target.files[0];
    let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
                avatar = e.target.result
        };
    }    

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.productos.access===false
                || ($miPermiso.productos.edit!==true && params.id!='new')
                || ($miPermiso.productos.insert!==true && params.id=='new')
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    /*$:if(precio) {
        precio=parseFloat(precio).toFixed(2)
    }*/

    // let kardex=function() {
    //     push('/kardex/'+codigo)
    // }

    let salir=function() {
        push('/productos')
    }

    let save=function() {

        if(loader===false) return;

        disabled=true;
        
        if(id!='new') {
            postData($urlapi, [{ 
                'cmd':'productos_editSave', 
                'id':id,
                'nombre':nombre.toUpperCase(),
                'precio':precio,
                'avatar':avatar,
                'color':color,
                'codigo':codigo,
                'visualizar':visualizar,
                'editable':editable,
                'sucursal':$sucursal
            }])
            .then(data => {
                push('/productos')
            });
        } else {
            postData($urlapi, [{ 
                'cmd':'productos_insertSave',
                'nombre':nombre,
                'precio':precio,
                'avatar':avatar,
                'color':color,
                'codigo':codigo,
                'visualizar':visualizar,
                'editable':editable,
                'sucursal':$sucursal
            }])
            .then(data => {
                push('/productos')
            });            
        }

    }    

    if(id!='new') {
        postData($urlapi, [{ 'cmd':'productos_edit', 'id':id, 'sucursal':$sucursal }])
        .then(data => {
                if(data[0].result===false) {
                    push('/productos')
                } else {
                    visualizar=Boolean(Number(data[0].result.productos[0].visualizar));
                    editable=Boolean(Number(data[0].result.productos[0].editable));
                    codigo=data[0].result.productos[0].codigo;
                    color=data[0].result.productos[0].color;
                    nombre=data[0].result.productos[0].nombre;
                    precio=data[0].result.productos[0].precio;
                    existencia=data[0].result.productos[0].existencia;
                    avatar=data[0].result.productos[0].imageBASE64;
                    disabled=false;
                    loader=true;
                }
        });
        insertando=false;
    } else {
        insertando=true;
        disabled=false;
        loader=true;        
    }

    let handleKeydown=function(event) { 
        if(event.keyCode==13) save()
        if(event.keyCode==27) salir()
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

{#if viewPage}

<Navbar />

<AnimationContainer>

    <Titlesection>
        <svelte:fragment slot="title"><i class="bi bi-box-seam me-1" />Productos
            <small class='badge bg-light text-success text-uppercase'>
            {#if insertando===true}
                Nuevo
            {:else}
                ID {id}
            {/if}
            </small>    
        </svelte:fragment>
        <svelte:fragment slot="toolbar">
            <button disabled={disabled} class="btn btn-success btn-md" on:click={save} on:mouseenter={()=>helper='Guardar'} on:mouseleave={()=>helper=false}><i class="bi bi-save"></i></button>
            <!-- {#if insertando===false}
                <button disabled={disabled} class="btn btn-info btn-sm" on:click={kardex} on:mouseenter={()=>helper='Kardex'} on:mouseleave={()=>helper=false}><i class="bi bi-file-earmark-spreadsheet"></i></button>
            {/if} -->
            <button class="btn btn-warning btn-sm" on:click={salir} on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}><i class="bi bi-box-arrow-in-left"></i></button>
        </svelte:fragment>
    </Titlesection>
    
    <div class="container mt-2">
        <div class="row">
            <div class="col-12 col-lg-6">

                    <div class="row bg-light pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">CODIGO</label>
                        <div class="col-sm-10">
                            <!-- svelte-ignore a11y-autofocus -->
                            <input disabled={disabled} type="text" class="form-control" bind:value={codigo} autofocus>
                        </div>
                    </div>                

                    <div class="row pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">NOMBRE</label>
                        <div class="col-sm-10">
                            <!-- svelte-ignore a11y-autofocus -->
                            <input disabled={disabled} type="text" class="form-control uppercase" bind:value={nombre}>
                        </div>
                    </div>
                    
                    <div class="row bg-light pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">PRECIO</label>
                        <div class="col-sm-10">
                            <input disabled={disabled} type="number" class="form-control" bind:value={precio} min="0.00" step="0.01" lang="en">
                        </div>
                    </div>

                    {#if insertando===false}
                        <div class="row pt-2 pb-2">
                            <label for="inputPassword" class="col-sm-2 col-form-label">EXISTENCIA</label>
                            <div class="col-sm-10 pt-2">
                                {existencia} Unidad(es) <span class="badge bg-secondary">{$sucursalStore[$sucursal]}</span>
                            </div>
                        </div>
                    {/if}

                    <div class="row pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">COLOR</label>
                        <div class="col-sm-10">
                            <input disabled={disabled} type="color" class="form-control form-control-color" bind:value={color} title="Cambia el color">
                        </div>
                    </div>

                    <div class="row bg-light pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label lh-1">PRECIO EDITABLE</label>
                        <div class="col-sm-10">
                            <div class="form-check form-switch mt-2">
                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefaultEditable" bind:checked={editable} disabled={disabled} >
                                <label class="form-check-label text-muted" for="flexSwitchCheckDefaultEditable">permite editar el precio</label>
                            </div>                            
                        </div>
                    </div>

                    <div class="row pt-2 pb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">VISIBLE</label>
                        <div class="col-sm-10">
                            <div class="form-check form-switch mt-2">
                                <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefaultVisible" bind:checked={visualizar} disabled={disabled} >
                                <label class="form-check-label text-muted" for="flexSwitchCheckDefaultVisible">visualizar botón en la ayuda rápida</label>
                            </div>                            
                        </div>
                    </div>
                    
                    {#if disabled===false}
                    <div class="row bg-light pt-2 pb-3 mb-2">
                        <label for="inputPassword" class="col-sm-2 col-form-label">ICONO</label>
                        <div class="col-sm-10">
                                {#if avatar}
                                    <img class="avatar" src="{avatar}" alt='' />
                                {:else}
                                    <img class="avatar" src="images/image-default.png" alt='' /> 
                                {/if}
                                <div class='d-flex'>
                                    <div class='text-center' style='width:100px;'>
                                        <img class="upload mt-1 m-auto" src="images/change-file.png" alt="" on:click={()=>{fileinput.click();}} />
                                        <div class="chan lh-1" on:click={()=>{fileinput.click();}}>Cambiar<br/>Imagen</div>
                                    </div>
                                    {#if avatar}
                                    <div class='text-center' style='width:100px;'>
                                        <img class="upload mt-1 m-auto" src="images/delete-file.png" alt="" on:click={()=>{avatar=false;}} />
                                        <div class="chan lh-1" on:click={()=>{avatar=false;}}>Eliminar<br/>Imagen</div>
                                    </div>
                                    {/if}
                                </div>
                                <input style="display:none" type="file" accept=".png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >
                                <div class="alert alert-info pt-0 pb-0 mt-3" role="alert">Subir imagen PNG cuadrada transparente</div>
                            </div>
                    </div>
                    {/if}

            </div>
            <div class="col-12 col-lg-6">
                <div style='width:200px;' class='float-lg-end'>
                    <BotonCaja
                        imageBASE64={avatar}
                        color={color}
                        precio={precio}>
                        {nombre.toUpperCase()}
                    </BotonCaja>
                </div>
            </div>
        </div>
    </div>

    <Helper bind:text={helper}></Helper>
    <br/><br/>
</AnimationContainer>
{/if}

<style>
 
	.upload{
		display:flex;
	    height:50px;
		width:50px;
		cursor:pointer;
	}
	.avatar{
		display:flex;
		height:100px;
		width:100px;
        border:2px dashed #b3b3b3;
        border-radius: 5px;;
	}
    .uppercase {
        text-transform: uppercase;
    }
</style>
